import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

export const RATING_STYLES = {
  green: { dot: 'bg-emerald-500', pill: 'bg-emerald-50 text-emerald-800 ring-emerald-200', label: 'Healthy' },
  amber: { dot: 'bg-amber-500', pill: 'bg-amber-50 text-amber-800 ring-amber-200', label: 'Needs attention' },
  red: { dot: 'bg-red-500', pill: 'bg-red-50 text-red-700 ring-red-200', label: 'At risk' },
};

const FACTOR_LABELS = { overdue: 'Overdue tasks', documents: 'Missing documents', invoices: 'Unpaid invoices', retainer: 'Hours vs retainer' };

export const HealthBreakdown = ({ health }) => (
  <div className="space-y-3" data-testid="health-breakdown">
    {Object.entries(health.factors).map(([k, f]) => (
      <div key={k} data-testid={`health-factor-${k}`}>
        <div className="flex items-center justify-between text-sm">
          <span className="text-stone-700">{FACTOR_LABELS[k]}</span>
          <span className="font-semibold text-stone-900 tabular-nums">{f.points}/{f.weight}</span>
        </div>
        <div className="mt-1 h-1.5 rounded-full bg-stone-100 overflow-hidden">
          <div className={`h-full ${f.points / f.weight >= 0.75 ? 'bg-emerald-500' : f.points / f.weight >= 0.5 ? 'bg-amber-500' : 'bg-red-500'}`} style={{ width: `${(f.points / f.weight) * 100}%` }}/>
        </div>
        <div className="mt-0.5 text-[11px] text-stone-500">{f.detail}</div>
      </div>
    ))}
  </div>
);

export const HealthBadge = ({ health, testid }) => {
  if (!health) return <span className="text-xs text-stone-400">—</span>;
  const s = RATING_STYLES[health.rating];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold ring-1 ${s.pill}`} data-testid={testid}>
          <span className={`h-2 w-2 rounded-full ${s.dot}`}/> {health.score}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72">
        <div className="font-semibold text-stone-900 text-sm mb-3">Health score · {s.label}</div>
        <HealthBreakdown health={health}/>
      </PopoverContent>
    </Popover>
  );
};
